<template>
  <widget-container
      :url="url"
      headlineclass
      cardclass="ma-0 pa-1"
      color="transparent"
      :bus="bus"
      :dark="false"
      :flat="true"
      :alwaysrender="true"
      @ready="setData"
  >
    <template slot="content">
      <div class>
        <v-row align="center">
          <v-col>
            <v-subheader>Répartition du CA par Destinations</v-subheader>
            <v-data-table
                class="mb-4"
                :headers="headers"
                :items="data"
                dense
                :footer-props="{
                'items-per-page-options': rowsPerPageItems,
                'items-per-page-text': 'Lignes par page',
              }"
                :loading="loading"
            >
              <template #item.ca="{ item }">
                {{ item.ca | currency("EUR") }}
              </template>
              <template #item.ha="{ item }">
                {{ item.ha | currency("EUR") }}
              </template>


              <template #item.markup="{ item }"> {{ item.markup | decimal({maximumFractionDigits: 2}) }} %</template>
              <template #header.actions>
                <div>
                  <v-icon small @click="copy" class="pl-2">mdi-clipboard-text-outline</v-icon>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </template>
  </widget-container>
</template>
<script>
import WidgetContainer from "./WidgetContainer";
import clipboard from "@/utils/clipboard";

export default {
  name: "WidgetNetworkStatsByDesti",
  components: {WidgetContainer},
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      rowsPerPageItems: [{text: "Tous", value: -1}, 50, 200],
      headers: [
        {text: "Destination", value: "destinationName", sortable: true},
        {text: "Dossiers", value: "nbBookings", sortable: true},
        {text: "CA", value: "ca", sortable: true},
        {text: "HA", value: "ha", sortable: true},
        {text: "Marge", value: "markup", sortable: true},
        {text: "", value: "actions", sortable: false, width: "40px"},
      ],
    };
  },
  created() {
    this.$nextTick(() => {
      this.bus.$on("search", () => {
        this.loading = true;
      });
    });
  },
  destroyed() {
    this.bus.$off("search");
  },
  methods: {
    setData(data) {
      this.data = data;
      this.loading = false;
    },

    copy() {
      const separator = "\t";
      const tmpHeaders = this.headers.map(h => h.text + separator).join(" ")

      const rows = this.data.map((i) => {
        const rowObj =
            {
              destinationName: i.destinationName,
              nbBookings: i.nbBookings,
              ca: i.ca,
              ha: i.ha,
              markup: Math.round(i.markup*100)/100,
            }

        return `${Object.values(rowObj).join(separator)}`;
      });

      const allRows = [tmpHeaders].concat(rows);
      clipboard.copyTextToClipboard(allRows.join("\n"));
      return allRows.join("\n")
    },
  },
};
</script>

